// extracted by mini-css-extract-plugin
module.exports = {"sitename__header":"sitename_sitename__header__1bx3v","sitename__header_bg":"sitename_sitename__header_bg__18Idu"};